import { BaseModel } from '../../core/abstractions/base.model';

export class RouteDataModel extends BaseModel {
    path = '';
    title = '';
    titleParams?: any;
    icon = '';
    class = '';
    isParentForSubMenu = false;
    isSubMenu = false;
    children: RouteDataModel[] = [];
    parent?: RouteDataModel;

    constructor(init?: Partial<RouteDataModel>) {
        super();
        Object.assign(this, init);
    }

    getFullPath(): string[] {
        let path: string[] = [];
        let parent = this.parent;

        while (parent) {
            path.push(`/${parent.path}`);
            parent = parent.parent;
        }

        const hasAnyPath = path.length > 0;
        path = path.reverse();

        if (!!this.path) {
            path.push(`${hasAnyPath ? '' : '/'}${this.path}`);
        }

        return path;
    }
}
